import React from "react";
import { VideoCamera } from "@phosphor-icons/react";

/**
 * Vimeo Event embed at a fixed 16:9 aspect ratio.
 * Use for the in-app live streams (3 distinct Vimeo Events power Plenary/Concurrent 1,
 * Concurrent 2 and Concurrent 3).
 */
export function LiveStreamEmbed({ url, label, testid = "live-stream-embed" }) {
  if (!url) {
    return (
      <div data-testid={`${testid}-missing`} className="aspect-video w-full grid place-items-center bg-[#1c1c24] text-[#7A828C] text-xs font-mono-time uppercase tracking-widest">
        Stream not yet live
      </div>
    );
  }
  return (
    <div className="space-y-2" data-testid={testid}>
      {label && (
        <div className="flex items-center gap-2 text-xs font-mono-time uppercase tracking-widest text-[#7A828C]">
          <VideoCamera size={14} className="text-[#DC4F48]" weight="fill" />
          <span>Live · {label}</span>
        </div>
      )}
      <div className="relative w-full overflow-hidden rounded-sm border border-[#E5E9F0] bg-[#1c1c24]" style={{ paddingTop: "56.25%" }}>
        <iframe
          src={url}
          title={label || "Live stream"}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture; encrypted-media; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="absolute top-0 left-0 w-full h-full"
        />
      </div>
    </div>
  );
}
